"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidateRawMap = void 0;
const ajv_1 = __importDefault(require("ajv"));
exports.ValidateRawMap = ajv_1.default().compile({
    definitions: {
        NoteBase: {
            type: "object",
            properties: {
                time: { type: "number", minimum: 0 },
                lane: { type: "integer", minimum: 0, maximum: 6 },
            },
            required: ["time", "lane"],
        },
        Single: {
            allOf: [
                { $ref: "#/definitions/NoteBase" },
                {
                    type: "object",
                    properties: {
                        type: { enum: ["single"] },
                        onbeat: { type: "boolean" },
                    },
                    required: ["type"],
                },
            ],
        },
        Flick: {
            allOf: [
                { $ref: "#/definitions/NoteBase" },
                {
                    type: "object",
                    properties: {
                        type: { enum: ["flick"] },
                    },
                    required: ["type"],
                },
            ],
        },
        Slide: {
            type: "object",
            properties: {
                id: { type: "number" },
                flickend: { type: "boolean" },
            },
            required: ["id"],
        },
        SlideNote: {
            allOf: [
                { $ref: "#/definitions/NoteBase" },
                {
                    type: "object",
                    properties: {
                        type: { enum: ["slide"] },
                        slideid: { type: "number" },
                    },
                    required: ["type", "slideid"],
                },
            ],
        },
    },
    type: "object",
    properties: {
        notes: {
            type: "array",
            items: {
                anyOf: [
                    { $ref: "#/definitions/Single" },
                    { $ref: "#/definitions/Flick" },
                    { $ref: "#/definitions/SlideNote" },
                ],
            },
        },
        slides: {
            type: "array",
            items: { $ref: "#/definitions/Slide" },
        },
    },
    required: ["notes", "slides"],
});
//# sourceMappingURL=RawMap.js.map